module.exports = __webpack_public_path__ + "img/tips4conimg.10474eec.jpg";